import PropTypes from 'prop-types';
import React from 'react';
import Button from '../components/Button';

const OkButton = ({ onClick, isPrimary }) => (
    <Button onClick={onClick} isPrimary={isPrimary} className="modal-btn" ariaLabel="OK" />
);

OkButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    isPrimary: PropTypes.bool.isRequired,
};

export default OkButton;
